import type { AgeRangeData, DemographicData } from '../../mockData/mockData';
import { genderNames, getRandomSegments } from '../../mockData/mockData';
import { BarChartTooltip } from '../BarChartTooltip';
import type { StreamType } from '../TrackStreamsGraph/TrackStreamsGraph';

export interface DemographicsTooltipProps {
  ageRange: keyof DemographicData;
  ageRangeData: AgeRangeData;
  totalStreams: number;
  streamType: StreamType;
}

export function DemographicsTooltip({
  ageRange,
  ageRangeData,
  totalStreams,
  streamType,
}: DemographicsTooltipProps) {
  const randomSegments = getRandomSegments();
  const genderBreakdown = genderNames.slice(0).map((gender, index) => ({
    label: gender,
    value: randomSegments[index - 1],
  }));

  return (
    <BarChartTooltip
      header={ageRange.toString()}
      data={ageRangeData}
      totalStreams={totalStreams}
      streamType={streamType}
      breakdown={genderBreakdown}
    />
  );
}

DemographicsTooltip.displayName = 'DemographicsTooltip';
